import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { IncidentDetailPatient } from 'sections/ube/features/IncidentDetail/useIncidentDetailForUbe';
import { TagList } from 'core/components/JianDetail/PatientDetailInfo/common/TagList';

type Props = {
  treatment: IncidentDetailPatient['treatments'][number];
};

export const TreatmentView = ({ treatment }: Props) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
      <SectionTitle text="処置" />
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="処置"
          content={<TagList tags={treatment?.data?.generalTreatments ?? []} />}
        />
      </div>
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="処置 自由記入欄"
          content={treatment?.data?.comment ?? ''}
        />
      </div>
      </div>
    </BorderedContainer>
  )
};
